import { EquipmentType, YardBlocksApi } from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class YardBlockService {
  httpClient = createApiClient(YardBlocksApi)

  async getYardBlocksByPartialName(filter?: string, equipmentTypes: EquipmentType[] = []) {
    const { data } = await this.httpClient.getYardBlockAreaByPartialName(filter, equipmentTypes)

    return data
  }
}

const yardBlockService = new YardBlockService()

export default yardBlockService
